<template>
  <div>
    <h1>Загрузка записей</h1>
  </div>
</template>

<script>
export default {
  name: "Loading",
};
</script>

<style>
</style>